import requirementConfig from '../constants/requirementConfig';

export const resolveConditionValue = (name, value) => {
  const config = requirementConfig[name];
  if (config && config.resolveValue) {
    return config.resolveValue(value);
  }

  return value;
};

export const resolveConditionActualValue = (name, value) => {
  const config = requirementConfig[name];
  if (config) {
    const { resolveActualValue, resolveValue } = config;
    const resolver = resolveActualValue || resolveValue;
    if (resolver) {
      return resolver(value);
    }
  }

  return value;
};

export const resolveConditionName = (condition) => {
  switch (condition.name) {
    case 'tags':
      return 'Tagged';
    default:
      return condition.label;
  }
};

export const operatorMap = {
  equal_to: 'must be',
  not_equal_to: 'must not be',
  greater_than: 'must be greater than',
  greater_than_or_equal_to: 'must be greater than or equal to',
  less_than: 'must be less than',
  less_than_or_equal_to: 'must be less than or equal to',
  non_empty: 'must not be empty',
  one_of: 'must be one of',
  not_one_of: 'must not be one of',
  contains_all: 'must contain all',
  is_contained_by: 'must be a subset of',
  shares_at_least_one_element_with: 'must be one of',
  shares_exactly_one_element_with: 'must be exactly one of',
  shares_no_elements_with: 'must not include',
  contains_one_of: 'must contain one of',
  does_not_contain: 'must not contain',
  is_true: 'is true',
  is_false: 'is false',
};
